import { render, staticRenderFns } from "./HeartshapedPlasticBadge.vue?vue&type=template&id=6da7bb7a&scoped=true&"
import script from "./HeartshapedPlasticBadge.vue?vue&type=script&lang=js&"
export * from "./HeartshapedPlasticBadge.vue?vue&type=script&lang=js&"
import style0 from "./HeartshapedPlasticBadge.vue?vue&type=style&index=0&id=6da7bb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7bb7a",
  null
  
)

component.options.__file = "HeartshapedPlasticBadge.vue"
export default component.exports